import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { memo } from "react";

export type ModalProps = {
	isOpen: boolean;
	onClose?: () => void;
	children: React.ReactNode;
	title?: string;
	closeButton?: boolean;
};

const modalVariants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1 },
	exit: { opacity: 0 },
};

function Modal({ isOpen, children, onClose }: ModalProps) {
	return (
		<AnimatePresence>
			{isOpen && (
				<motion.div
					onClick={onClose}
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "#000C18B3",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						margin: 0,
						zIndex: 1000,
						cursor: "default",
					}}
					className="transition"
					initial="hidden"
					animate="visible"
					exit="exit"
					variants={modalVariants}
					transition={{ duration: 0.3 }}
				>
					{children}
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export default memo(Modal);
